import { render, staticRenderFns } from "./InquiredTable.vue?vue&type=template&id=0319e830&"
import script from "./InquiredTable.vue?vue&type=script&lang=js&"
export * from "./InquiredTable.vue?vue&type=script&lang=js&"
import style0 from "./InquiredTable.vue?vue&type=style&index=0&id=0319e830&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports